export const routes = [

  {
    path: '/inscricao/auth/usuarios',
    component: () => import('./components/user'),
    name: 'inscricao.usuarios',
    meta: {
      requiresFullAdmin: true
    }
  },
  {
    path: '/inscricao/auth/usuarios/novo',
    component: () => import('./components/insertEdit'),
    name: 'inscricao.insert',
    meta: {
      requiresFullAdmin: true
    }
  },
  {
    path: '/inscricao/auth/usuarios/editar/:id',
    component: () => import('./components/insertEdit'),
    name: 'inscricao.edit',
    meta: {
      requiresFullAdmin: true
    }
  }


]
